<template>
    <div class="container">
        <header class="header">
            <span class="close" @click="goBack">
                <van-icon name="arrow-left" />
            </span>
        </header>
        <section class="content-wrap">
            <div class="card-warp">
                <van-tabs type="card" class="van-tabs-card" @click="onSwitchTab">
                    <van-tab title="正常缴纳">
                        <div class="card-top">
                            <p>总计应缴纳(元)</p>
                            <p style="font-weight: bold;font-size: 26px;margin-top:6px;">{{normalPay.totalPayable || '--'}}</p>
                        </div>
                        <div class="card-bottom">
                            <ul>
                                <li>
                                    <p>所在城市</p>
                                    <p>{{normalPay.areaName || '--'}}</p>
                                </li>
                                <li>
                                    <p>社保基数</p>
                                    <p>{{normalPay.baseAmount || '--'}}</p>
                                </li>
                                <li>
                                    <p>企业类型</p>
                                    <p>{{normalPay.businessName}}</p>
                                </li>
                                <li>
                                    <div class="lastli-style">
                                        <p class="lastli-active">企业人数</p>
                                        <p>{{normalPay.enterprisesNumber}}</p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </van-tab>
                    <van-tab title="疫情减免">
                        <div class="card-top">
                            <p>社保月缴额(元)<span style="margin-left:13px;font-weight: bold;font-size: 26px;">{{epidemicRelief.totalPayable || '--'}}</span></p>
                            <p>减免金额(元)<span style="margin-left:13px;font-size: 26px;font-size: 24px;">{{epidemicRelief.totalRelief || '--'}}</span></p>
                        </div>
                        <div class="card-bottom">
                            <ul>
                                <li>
                                    <p>所在城市</p>
                                    <p>{{epidemicRelief.areaName || '--'}}</p>
                                </li>
                                <li>
                                    <p>社保基数</p>
                                    <p>{{epidemicRelief.baseAmount || '--'}}</p>
                                </li>
                                <li>
                                    <p>企业类型</p>
                                    <p>{{epidemicRelief.businessName}}</p>
                                </li>
                                 <li>
                                    <div class="lastli-style">
                                        <p class="lastli-active">企业人数</p>
                                        <p>{{epidemicRelief.enterprisesNumber}}</p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </van-tab>
                </van-tabs>
            </div>
            <div class="main-warp">
                <table cellspacing="0" cellpadding="0">
                    <thead>
                        <tr>
                            <th>险种</th>
                            <th>基数</th>
                            <th>企业比例</th>
                            <th>企业金额</th>
                            <th>个人比例</th>
                            <th>个人金额</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for='(item,index) in list' :key="index">
                            <td>{{item.insuranceName || '--'}}</td>
                            <td>{{item.baseAmount || '--'}}</td>  
                            <td :class="[isMark && item.insuranceType !== 3 ? 'mark-red' : '']">{{item.enterprisesProportion === 0 ? 0 : (item.enterprisesProportion ? `${parseFloat((item.enterprisesProportion * 100).toPrecision(12))}%`: '--')}}</td>
                            <td :class="[isMark && item.insuranceType !== 3 ? 'mark-red' : '']">{{item.enterpriseAmount === 0 ? 0 : `${item.enterpriseAmount}`}}</td>
                            <td>{{item.personalProportion === 0 ? 0 : (item.personalProportion ? `${parseFloat((item.personalProportion * 100).toPrecision(12))}%` : '--')}}</td>
                            <td>{{item.personalAmount === 0 ? 0 : `${item.personalAmount}`}}</td>
                        </tr>
                    </tbody>
                </table>
                <p style="font-size:12px;color:#979797;margin-top:5px;">单位：元</p>
                <div class="description-warp">
                    <h4>说明：</h4>
                    <p>
                       1.社保缴费额仅供参考，最终缴纳额以社保局实际收取为准。
                    </p>
                    <p>
                       2.根据政策，部分城市生育保险企业比例已合并到医疗保险企业比例中。
                    </p>
                    <p>
                       3.根据政策，部分城市工伤、失业保险企业比例为浮动费率，具体比例要根据企业行业性质而定。
                    </p>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
  data() {
    return {
        dataSource: {}, // 数据
        normalPay: {}, // 正常缴纳
        epidemicRelief: {}, // 疫情减免
        list: [],  // 表格的数据
        isMark: false, // 是否标红
    };
  },

  mounted() {

  },

  created() {
    this.dataSource = JSON.parse(localStorage.getItem('successData'));
    this.normalPay = this.dataSource[0];
    this.epidemicRelief = this.dataSource[1];
    this.list = this.normalPay.socialSecurityReduceDetailVoList || [];
    // 表格添加总计
    this.addSum(this.list);
  },

  methods: {
    goBack() {
      this.$router.go(-1);
    },
    // 切换页签
    onSwitchTab(name) {
        if (name === 0) { // 正常缴纳
            this.list = this.normalPay.socialSecurityReduceDetailVoList || [];
            this.isMark = false;
            this.addSum(this.list);
        } else { // 疫情减免
            this.list = this.epidemicRelief.socialSecurityReduceDetailVoList || [];
            this.isMark = true;
            this.addSum(this.list);
        }
    },
    // 表格添加总计
    addSum(arr) {
        let oldArr =arr;
        let enterpriseAmountSum = 0;  // 企业金额总计
        let personalAmountSum = 0; // 个人金额总计
        oldArr.map(item => {
            enterpriseAmountSum += item.enterpriseAmount;
            personalAmountSum += item.personalAmount;
        })
        oldArr = oldArr.concat([{
            insuranceType: 3,
            insuranceName: '总计',
            baseAmount: '',
            enterprisesProportion: null,
            enterpriseAmount: '',
            personalProportion: null,
            personalAmount: '',
        }])
        // 给最后一行企业金额，个人金额计算总和
        oldArr[oldArr.length-1].enterpriseAmount = Number(enterpriseAmountSum.toFixed(2));
        oldArr[oldArr.length-1].personalAmount = Number(personalAmountSum.toFixed(2));
        this.list = oldArr;
    }
  }
};
</script>

<style scoped lang="less">
div {
   box-sizing: border-box;
}
.container{
    width: 100%;
    height: 100%;
    background:#fff;
    .header{
        height: 58px;
        background:#fff;
        line-height: 58px;
        .close .van-icon {
            font-size: 20px;
            color: #4A4A4A;
            padding: 0 16px;
        }
    }
    .content-wrap{
        .card-warp{
            height:196.7px;
            background:#3672EA;
            .van-tabs-card{
                padding-top: 10px;
            }
            .card-top{
                margin-top: 10px;
                color: #fff;
                p{
                    text-align: center;
                    font-size: 14px;
                    line-height: 25px;
                }
            }
            .card-bottom{
                margin-top: 20px;
                ul {
                    display: flex;
                    li{
                        flex: 1;
                        text-align: center;
                        color: #fff;
                        p{
                            line-height: 25px;
                        }
                        :first-child{
                            font-size: 10.5px;
                        }
                        :last-child{
                            font-size: 13px;
                        }
                    }
                    :last-child .lastli-style{
                        width: 56px;
                        border: 2px solid rgba(255,255,255,1);
                        border-radius: 2.5px;
                        margin: 0 auto;
                        .lastli-active{
                            background: #fff;
                            color: #3672EA;
                        }
                    }
                }
            }
        }
        .main-warp{
            padding: 0 12px;
            table{
                margin-top: 14px;
                width: 100%;
                thead{
                    tr{
                        background: #F4F1F4;
                    }
                    tr th{
                        font-size: 14px;
                        color:#252525;
                        text-align: center;
                        height: 30px;
                        line-height: 30px;
                        width: 16%;
                    }
                }
                tbody{
                    tr:nth-of-type(2n){
                        background: #F4F1F4;
                    }
                    tr td{
                        font-size: 14px;
                        color:#252525;
                        text-align: center;
                        height: 30px;
                        line-height: 30px;
                        width: 16%
                    }
                    tr td.mark-red{
                        color: #e60012;
                    }
                }
            }
            .description-warp{
                margin-top: 16px;
                h4{
                    color:#706D70;
                    font-size: 14px;
                    line-height: 20px;
                }
                p{
                    font-size:12px;
                    color:#706D70;
                    line-height: 24px;
                }
            }
        }
    }
}
/deep/ .van-tabs__nav--card {
    box-sizing: border-box;
    height: 21.45px;
    margin: 0 2.42667rem;
    border: 0.02667rem solid #fff;
    border-radius: 0.05333rem;
}
/deep/ .van-tabs__nav--card .van-tab {
    color: #fff;
    line-height: 21.45px;
    border-right: none;
}
/deep/ .van-tabs__nav--card .van-tab.van-tab--active {
    color: #3672EA;
    background-color: #fff;
}
/deep/ .van-tabs__nav {
    position: relative;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    background-color: #3672EA;
    -webkit-user-select: none;
    user-select: none;
}
</style>
